module.exports = __webpack_public_path__ + "static/media/fantsyland-img.f0e9f41c.png";